
import request from '@/utils/request'

export function getListProductCategoryApi(query) {
  return request({
    url: '/config-service/v1/product-portfolio/list',
    method: 'get',
    params: query
  })
}

export function addProductCategoryApi(query) {
  return request({
    url: '/config-service/v1/product-portfolio/add',
    method: 'post',
    data: query
  })
}

export function updateProductCategoryApi(query) {
  return request({
    url: '/config-service/v1/product-portfolio/update',
    method: 'put',
    data: query
  })
}

export function deleteProductCategoryApi(query) {
  return request({
    url: '/config-service/v1/product-portfolio/delete-ids',
    method: 'delete',
    data: query
  })
}
